import { render } from "./SysMess.vue?vue&type=template&id=f454dc6c&scoped=true"
import script from "./SysMess.vue?vue&type=script&lang=js"
export * from "./SysMess.vue?vue&type=script&lang=js"

import "./SysMess.vue?vue&type=style&index=0&id=f454dc6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f454dc6c"]])

export default __exports__